"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _store = _interopRequireDefault(require("./store"));

var _Contest = _interopRequireDefault(require("./Contest"));

var _defaultTranslations = _interopRequireDefault(require("./defaultTranslations"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      betbarParent = _ref.betbarParent,
      setBetbarParent = _ref.setBetbarParent,
      app = _ref.app,
      hidePopularPick = _ref.hidePopularPick,
      onPicksChanged = _ref.onPicksChanged,
      onPlaceBetClicked = _ref.onPlaceBetClicked,
      onPicksCleared = _ref.onPicksCleared,
      onRulesClicked = _ref.onRulesClicked,
      onTermsAndConditionsClicked = _ref.onTermsAndConditionsClicked,
      isHowToPlayAboveBanner = _ref.isHowToPlayAboveBanner,
      isLoggedIn = _ref.isLoggedIn,
      isClearingPicks = _ref.isClearingPicks,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages,
      isMobileVerificationDisabled = _ref.isMobileVerificationDisabled,
      hasCheckboxes = _ref.hasCheckboxes,
      hasQuestionStatBelowQuestion = _ref.hasQuestionStatBelowQuestion,
      GameBanner = _ref.GameBanner,
      hasSocialShareButton = _ref.hasSocialShareButton;

  if (!translations) {
    translations = _defaultTranslations.default;
  }

  console.log("translations", translations);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRedux.Provider, {
    store: _store.default,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Contest.default, {
      translations: translations,
      betbarParent: betbarParent,
      setBetbarParent: setBetbarParent,
      app: app,
      hidePopularPick: hidePopularPick,
      isHowToPlayAboveBanner: isHowToPlayAboveBanner,
      isMobileVerificationDisabled: isMobileVerificationDisabled,
      isClearingPicks: isClearingPicks,
      isLoggedIn: isLoggedIn,
      isUsingAlternativeImages: isUsingAlternativeImages,
      onRulesClicked: onRulesClicked,
      onPicksCleared: onPicksCleared,
      onPicksChanged: onPicksChanged,
      onPlaceBetClicked: onPlaceBetClicked,
      onTermsAndConditionsClicked: onTermsAndConditionsClicked,
      GameBanner: GameBanner,
      hasCheckboxes: hasCheckboxes,
      hasQuestionStatBelowQuestion: hasQuestionStatBelowQuestion,
      hasSocialShareButton: hasSocialShareButton
    })
  });
};

var _default = Wrapper;
exports.default = _default;